import { VoidCallback } from '@deqo/foundation';
import MarkdownIt from 'markdown-it';
import React from 'react';

const ruleSet = Object.freeze({
    // Core:
    'block': true,
    'inline': true,
    'linkify': false,
    'normalize': true,
    'replacements': true,
    'smartquotes': false,
    'text_join': true,

    // Block:
    'blockquote': false,
    'code': false,
    'fence': false,
    'heading': false,
    'hr': false,
    'html_block': false,
    'lheading': false,
    'list': false,
    'paragraph': false,
    'reference': false,
    'table': false,

    // Inline:
    'autolink': false,
    'backticks': false,
    'balance_pairs': true,
    'emphasis': true,
    'entity': true,
    'escape': true,
    'fragments_join': true,
    'html_inline': false,
    'image': false,
    'link': false,
    'newline': false,
    'strikethrough': true,
    'text': true,
});

const md = new MarkdownIt('default', { linkify: false });
md.enable(Object.entries(ruleSet).filter(x => x[1]).map(x => x[0]));
md.disable(Object.entries(ruleSet).filter(x => !x[1]).map(x => x[0]));

export type CompiledAlertBody = (React.ComponentType<{ onClose: VoidCallback }> | ((props: { onClose: VoidCallback }) => JSX.Element));
export type AlertBody = string | CompiledAlertBody;

export const AlertBody = {
    compile(body: AlertBody) {
        if (typeof (body) === 'string') {
            return () => <div dangerouslySetInnerHTML={{ __html: md.renderInline(body) }} />;
        }
        else {
            return body;
        }
    }
};
